import { useEffect, useRef, useState } from "react";
import useWindowSize from "../../hook/useWindowSize";

import clsx from "clsx";
import './Marquee.css';

function Marquee({
  items,
  direction
}) {

  const [elements, setElements] = useState([]);
  const [isAnimated, setAnimated] = useState(true);
  const listRef = useRef(null);
  const windowSize = useWindowSize();

  useEffect(() => {
    const newElements = items.map((item, i) => {
      return (
        <li key={i} className="logo-wrapper">
          <a href={item.link} target="_blank" rel="noreferrer">
            <img src={item.src} alt={item.alt} />
          </a>
        </li>
      );
    });
    setElements(newElements);
  }, [items]);

  useEffect(() => {
    if (listRef && listRef.current?.getBoundingClientRect().width > 0) {
      if (windowSize.width < listRef.current.getBoundingClientRect().width) {
        setAnimated(true);
      } else {
        setAnimated(false);
      }
    }
  }, [windowSize]);

  return (
    <div className="marquee">
      <div className={clsx(
        'marquee-wrapper',
        direction === 'ltr' ? 'marquee-ltr' : 'marquee-rtl',
        isAnimated && 'animated'
      )}>
        <ul ref={listRef} className="marquee-content">
          {elements}
        </ul>

        {isAnimated && (
          <ul aria-hidden="true" className="marquee-content">
            {elements}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Marquee;